import { useMutation } from "@tanstack/react-query";
import { ResetPasswordPayload } from "../interfaces/reset-password.interface";
import { SendResetPasswordEmailPayload } from "../interfaces/send-reset-password-email.interface";
import { resetPassword, sendResetPasswordEmail } from "../services/auth.service";

export const useResetPassword = () => {
  return useMutation({
    mutationFn: (payload: ResetPasswordPayload) => resetPassword(payload),
  });
};

export const useSendResetPasswordEmail = () => {
  return useMutation({
    mutationFn: (payload: SendResetPasswordEmailPayload) => sendResetPasswordEmail(payload),
  });
};
